import { render, staticRenderFns } from "./TheNavItem.vue?vue&type=template&id=3731d60b&scoped=true&"
import script from "./TheNavItem.vue?vue&type=script&lang=ts&"
export * from "./TheNavItem.vue?vue&type=script&lang=ts&"
import style0 from "./TheNavItem.vue?vue&type=style&index=0&id=3731d60b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3731d60b",
  null
  
)

export default component.exports